/**
 * LiveFlight Filters Module
 * Handles sorting and filtering of flight results
 */

/**
 * Filters state properties
 */
export const state = {
  // Sorting
  sort_by: "price",

  // Carrier filter
  filter_carriers: [],

  // Provider filter (dev-only UI — the predicate runs unconditionally but
  // stays a no-op in prod because nothing ever populates it)
  filter_providers: [],

  // Time filters - outbound
  filter_round_trip_departure: "",
  filter_round_trip_arrival: "",

  // Time filters - return
  filter_return_trip_departure: "",

  // Availability filter
  filter_availability: false,

  // Price range filter
  filter_price_range: {},
  filter_price_settings: {},

  // Baggage filters
  filter_included_bags: false,
  filter_extra_bags: false,
};

/**
 * Custom mutations for filters state
 */
export const mutations = {
  // Reset all filters to default values
  reset_filters(state) {
    state.filter_carriers = [];
    state.filter_providers = [];
    state.filter_round_trip_departure = "";
    state.filter_round_trip_arrival = "";
    state.filter_return_trip_departure = "";
    state.filter_availability = false;
    state.filter_price_range = {};
    state.filter_price_settings = {};
    state.filter_included_bags = false;
    state.filter_extra_bags = false;
  },
};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = [
  "sort_by",
];
